import { CUSTOM_ELEMENTS_SCHEMA, Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from './core/components/navigation/navigation.component';
import { LoadingIndicatorComponent } from './core/components/loading-indicator/loading-indicator.component';
import { AuthService } from './core/services/auth-service/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavigationComponent, LoadingIndicatorComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  constructor(protected authService: AuthService) {}
}
